import { useContext } from "react";
import { DashboardContext } from "Context/Dashboard";

export const useDashboard = () => useContext(DashboardContext);
